import React, { useState } from 'react';
import { Star } from 'lucide-react';

// Read-only or interactive star rating.
// - value: current rating (can be fractional for display)
// - onChange: if provided, stars become interactive (integer 1..5)
// - size: pixel size of each star
export const StarRating = ({ value = 0, onChange, size = 20, className = '', ariaLabel }) => {
  const [hover, setHover] = useState(0);
  const interactive = typeof onChange === 'function';
  const active = hover || value;

  return (
    <div
      className={`inline-flex items-center gap-0.5 ${className}`}
      role={interactive ? 'radiogroup' : 'img'}
      aria-label={ariaLabel || `${Number(value).toFixed(1)} / 5`}
    >
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= Math.round(active);
        const star = (
          <Star
            style={{ width: size, height: size }}
            className={filled ? 'fill-amber-400 text-amber-400' : 'fill-transparent text-muted-foreground/40'}
            strokeWidth={1.75}
          />
        );
        if (!interactive) {
          return <span key={i} aria-hidden="true">{star}</span>;
        }
        return (
          <button
            key={i}
            type="button"
            role="radio"
            aria-checked={value === i}
            aria-label={`${i}`}
            onClick={() => onChange(i)}
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(0)}
            className="rounded-sm p-0.5 transition-transform duration-150 hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            data-testid={`review-star-${i}`}
          >
            {star}
          </button>
        );
      })}
    </div>
  );
};
